<script>
    export default {
        name: 'ComponentsEmptyLocal',
        props: {
            image: { type: String, default: 'images/sys-tip/loading.gif' },
            description: { type: String, default: '努力加载中...' },
            imageStyle: { type: Object, default: () => {} },
            status: { type: Number, default: 0 }, // 0 加载中，1 暂无数据
        },
        render() {
            if (this.status === 1) {
                this.image = 'images/sys-tip/empty.png';
            }
            return <div class="components-empty-state ant-empty">
                        <div class="components-empty-img ant-empty-image"><img src={this.image} /></div>
                        <div class="empty-state-text ant-empty-description">{this.description}</div>
                    </div>;
        }
    };
</script>
